<template>
  <main>
    <v-sheet>
      <v-container class="tw-p-2 sub-navigation">
        <v-chip-group right v-model="activeChip" center-active mandatory active-class="tw-bg-primary tw-text-white">
          <v-chip small v-for="item in categories" :key="item.text" :value="item.text">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-container>
    </v-sheet>

    <div class="tw-flex tw-relative tw-min-h-full">
      <v-navigation-drawer v-model="show.navigation"
                           style="min-width: 256px"
                           floating
                           :permanent="$vuetify.breakpoint.mdAndUp"
                           :app="$vuetify.breakpoint.smAndDown"
                           :class="{'tw-mt-4 tw-bg-transparent': $vuetify.breakpoint.mdAndUp}"
                           class="fill-height tw-py-20">
        <v-container>
          <v-list dense nav class="md:tw-text-right">
            <v-list-item>
              <v-list-item-title class="text-h6">Tools</v-list-item-title>
            </v-list-item>
            <v-list-item-group :value="1" color="primary">
              <v-list-item v-for="(item, index) in toolsList" :key="index">
                <v-list-item-content>
                  <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-container>
      </v-navigation-drawer>
      <v-container>
        <v-card>
          <v-card-title>
            Farm Monitor
            <v-spacer />
            <div>
              <ShareNetwork
                  v-for="network in networks"
                  :network="network.network"
                  :key="network.network"
                  :url="sharing.url"
                  :title="sharing.title"
                  :description="sharing.description"
                  :quote="sharing.quote"
                  :hashtags="sharing.hashtags"
                  :twitterUser="sharing.twitterUser"
                  class="tw-ml-2"
              >
                <v-btn icon outlined :color="network.color">
                  <v-icon>{{ network.icon }}</v-icon>
                </v-btn>
              </ShareNetwork>
            </div>
          </v-card-title>
        </v-card>
        <v-row dense>
          <v-col :cols="12" :lg="8">
            <v-card :id="`chart1`" class="tw-mt-4">
              <v-card-title>Weather Info</v-card-title>
              <v-container>
                <c-data-list v-model="siteSampleData" />
              </v-container>
            </v-card>
          </v-col>
          <v-col :cols="12" :lg="4">
            <v-card :id="`chart2`" style="height: calc(100% - 16px)" class="tw-mt-4">
              <v-subheader class="tw-text-primary">Chart 2</v-subheader>
            </v-card>
          </v-col>
          <v-col :cols="12" :lg="12">
            <v-card :id="`chart3`" style="height: 400px" class="tw-mt-4">
              <v-subheader class="tw-text-primary">Chart 3</v-subheader>
            </v-card>
          </v-col>
          <v-col :cols="12" :lg="12">
            <v-card :id="`chart4`" style="height: 400px" class="tw-mt-4">
              <v-subheader class="tw-text-primary">Chart 4</v-subheader>
            </v-card>
          </v-col>
          <v-col :cols="12" :lg="6">
            <v-card :id="`chart5`" style="height: 400px" class="tw-mt-4">
              <v-subheader class="tw-text-primary">Chart 5</v-subheader>
            </v-card>
          </v-col>
          <v-col :cols="12" :lg="6">
            <v-card :id="`chart6`" style="height: 400px" class="tw-mt-4">
              <v-subheader class="tw-text-primary">Chart 6</v-subheader>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
      <table-of-content :toc="toc" class="tw-bg-transparent tw-sticky tw-mt-32" style="top: 80px" />
      <v-fade-transition>
        <v-btn v-if="!show.navigation"
               fab fixed color="primary"
               class="tw-bottom-0 tw-right-0 tw-z-10 tw-m-6"
               @click="show.navigation = !show.navigation"
        >
          <v-icon>
            mdi-format-list-bulleted
          </v-icon>
        </v-btn>
      </v-fade-transition>
    </div>
  </main>
</template>

<script>
import agricultureCategory from '@/common/data/algricultureCategory'
import TableOfContent from '@/components/common/TableOfContent'
import toolSampleList from '@/common/data/toolSampleList'
import siteSampleData from '@/common/data/siteSampleData'
export default {
  name: 'white',
  components: { TableOfContent },
  layout: 'CardLayout',
  data () {
    return {
      activeChip: 'Corns',
      categories: agricultureCategory,
      toolsList: toolSampleList,
      siteSampleData,
      show: {
        navigation: true
      },
      toc: [
        {
          id: 'chart1',
          text: 'Single Chart 1'
        },
        {
          id: 'chart2',
          text: 'Single Chart 2'
        },
        {
          id: 'chart3',
          text: 'Single Chart 3'
        },
        {
          id: 'chart4',
          text: 'Single Chart 4'
        },
        {
          id: 'chart5',
          text: 'Single Chart 5'
        },
        {
          id: 'chart6',
          text: 'Single Chart 6'
        }
      ],
      sharing: {
        url: 'https://igws.indiana.edu',
        title: 'Hello from IGWS!',
        description: 'This week, I’d like to introduce you to "Vite", which means "Fast". It’s a brand new development setup created by Evan You.',
        quote: 'The hot reload is so fast it\'s near instant. - Evan You',
        hashtags: 'IGWS,IU',
        twitterUser: 'igws'
      },
      networks: [
        { network: 'email', name: 'Email', icon: 'mdi-email', color: '#333333' },
        { network: 'facebook', name: 'Facebook', icon: 'mdi-facebook', color: '#1877f2' },
        { network: 'twitter', name: 'Twitter', icon: 'mdi-twitter', color: '#1da1f2' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-navigation::v-deep .v-slide-group__content{
  justify-content: flex-end;
}
</style>
